@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.pcos.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.pcos.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_158_838_654)
internal val Res.drawable.brand: DrawableResource by lazy {
      DrawableResource("drawable:brand", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectJsMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brand", Res.drawable.brand)
}
